<form (ngModelChange)="formChanged()" [formGroup]="validateRegisterForm" autocomplete="off" class="signup-form"
	  nz-form (keydown.enter)="$event.preventDefault()">

	<!--<nz-input-group [nzPrefix]="prefixIcon" class="icons custom-select mb-1">
		<nz-select [(ngModel)]="selectedUserType" [nzDropdownStyle]="dropDownStyle" [nzSize]="'large'"
				   class="color-grey full-width" formControlName="organizationType" nzBorderless>
			<nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label | translate"
					   [nzValue]="option.value">
			</nz-option>
		</nz-select>
	</nz-input-group>
	<ng-template #prefixIcon>
		<svg fill="none" height="13" viewBox="0 0 16 13" width="16" xmlns="http://www.w3.org/2000/svg">
			<path d="M11.332 8.5H12.6654V9.83333H11.332V8.5Z" fill="#2496BE"/>
			<path d="M12.6654 5.83331H11.332V7.16665H12.6654V5.83331Z" fill="#2496BE"/>
			<path clip-rule="evenodd"
				  d="M8.66602 3.16667H15.3327V12.5H0.666016V0.5H8.66602V3.16667ZM5.33268 1.83333H7.33268V3.16667H5.33268V1.83333ZM7.33268 11.1667V9.83333H5.33268V11.1667H7.33268ZM7.33268 8.5V7.16667H5.33268V8.5H7.33268ZM7.33268 5.83333V4.5H5.33268V5.83333H7.33268ZM13.9993 11.1667V4.5H8.66602V5.83333H9.99935V7.16667H8.66602V8.5H9.99935V9.83333H8.66602V11.1667H13.9993ZM1.99935 11.1667V9.83333H3.99935V11.1667H1.99935ZM1.99935 8.5H3.99935V7.16667H1.99935V8.5ZM3.99935 5.83333V4.5H1.99935V5.83333H3.99935ZM1.99935 3.16667H3.99935V1.83333H1.99935V3.16667Z"
				  fill="#2496BE"
				  fill-rule="evenodd"/>
		</svg>
	</ng-template>
	-->

	<app-input-field [formName]="'organization'" [form]="validateRegisterForm"
					 [label]="'global.login.label.organization_name' | translate" [size]="'large'"
					 [placeholder]="'global.login.placeholder.organization_field' | translate"
					 class="organization-field">
	</app-input-field>

	<app-input-field [formName]="'email'" [form]="validateRegisterForm" [label]="'global.login.label.email' | translate"
					 [placeholder]="'global.login.placeholder.email' | translate" [size]="'large'"
					 class="organization-field">
	</app-input-field>

	<app-input-field [formName]="'firstName'" [form]="validateRegisterForm"
					 [label]="'global.login.label.first_name' | translate"
					 [placeholder]="'global.login.placeholder.first_name' | translate" [size]="'large'"
					 class="organization-field">
	</app-input-field>

	<app-input-field [formName]="'lastName'" [form]="validateRegisterForm"
					 [label]="'global.login.label.last_name' | translate"
					 [placeholder]="'global.login.placeholder.last_name' | translate" [size]="'large'"
					 class="organization-field">
	</app-input-field>

	<app-input-field [formName]="'website'" [form]="validateRegisterForm"
					 [label]="'global.common.website' | translate"
					 [placeholder]="'global.common.website' | translate" [size]="'large'"
					 class="organization-field">
	</app-input-field>

	<app-password-field (password)="password = $event" (passwordValid)="passwordValid = $event"></app-password-field>

	<div class="terms-conditions" nz-row>
		<div> {{ "global.sign_up.label.by_clicking_register" | translate }}
			<a [href]="termsAndConditionsUrl">{{ "global.sign_up.label.terms_and_conditions" | translate }}</a>
			{{ "global.sign_up.label.and" | translate }}
			<a [href]="privacyPolicyUrl">{{ "global.sign_up.label.privacy_policy" | translate }}</a>
		</div>
	</div>

	<div nz-row>
		<div *ngIf="showBuyerRegistrationButton && showSupplierRegistrationButton && !invitedType; else elseRegistrationButton" [nzSpan]="24" nz-col>
			<button (click)="submitRegisterForm('buyer')" [disabled]="!(validateRegisterForm.valid) || !passwordValid"
					[nzType]="'primary'"
					class="login-form-button login-form-margin mt-1 ant-btn ant-btn-primary ant-btn-block btn-color-default"
					nz-button>
				{{ "global.login.label.register_as_buyer" | translate }}
			</button>
			<div  class="d-flex text-center vertical-align-middle center" id="devider">
				{{ "global.common.or" | translate }}
			</div>
			<button (click)="submitRegisterForm('supplier')"
					[disabled]="!(validateRegisterForm.valid) || !passwordValid" [nzType]="'primary'"
					class="login-form-button login-form-margin mt-1 ant-btn ant-btn-primary ant-btn-block btn-color-default"
					nz-button>
				{{ "global.login.label.register_as_supplier" | translate }}
			</button>
		</div>
		<ng-template [nzSpan]="24" nz-col #elseRegistrationButton>
			<button (click)="submitRegisterForm(invitedType)" [disabled]="!(validateRegisterForm.valid) || !passwordValid"
					[nzType]="'primary'"
					class="login-form-button login-form-margin mt-1 ant-btn ant-btn-primary ant-btn-block btn-color-default"
					nz-button>
				{{ invitedType === 'buyer'
					? ("global.login.label.register_as_buyer" | translate)
					: invitedType === 'supplier'
						? ("global.login.label.register_as_supplier" | translate)
						: ("global.login.label.sign_up" | translate) }}
			</button>
		</ng-template>
		<!--<div [nzSpan]="13" class="account" nz-col>
			<a href="auth/login">{{ "global.login.label.i_have_account" | translate }}</a>
		</div>-->
	</div>

</form>
